import { gql } from "@apollo/client";

export const GetSwConfigVariables = gql`
  query GetSwConfigVariables(
    $token: String!
    $customerID: ID!
    $input: ConfigQuery!
  ) {
    GetSwConfigVariables(
      token: $token
      customerID: $customerID
      input: $input
    ) {
      id
      configKey
      mode
      hideThisKey
      formLabelCaption
      module
      dataStorageType
      dependsOnPrimaryList
      dependsOnSecondaryList
      primaryListKey
      secondaryListKey
      tableHeader
      booleanValue
      integerValue
      doubleValue
      str1Value
      str2Value
      dateValue
      keyShowIndex
      keyOrderIndex
      customerID
    }
  }
`;

export const SwConfigByNode = gql`
  query SwConfigByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on SwConfigVariables {
        id
        configKey
        mode
        hideThisKey
        formLabelCaption
        module
        dataStorageType
        dependsOnPrimaryList
        dependsOnSecondaryList
        primaryListKey
        secondaryListKey
        tableHeader
        booleanValue
        integerValue
        doubleValue
        str1Value
        str2Value
        dateValue
        keyShowIndex
        keyOrderIndex
        customerID
      }
    }
  }
`;

